import { render } from "./MultilingualTextarea.vue?vue&type=template&id=1a5e8119&scoped=true"
import script from "./MultilingualTextarea.vue?vue&type=script&lang=js"
export * from "./MultilingualTextarea.vue?vue&type=script&lang=js"

import "./MultilingualTextarea.vue?vue&type=style&index=0&id=1a5e8119&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5e8119"],['__file',"src/common/components/MultilingualTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a5e8119"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a5e8119', __exports__)) {
    api.reload('1a5e8119', __exports__)
  }
  
  module.hot.accept("./MultilingualTextarea.vue?vue&type=template&id=1a5e8119&scoped=true", () => {
    api.rerender('1a5e8119', render)
  })

}


export default __exports__